export default "__VITE_ASSET__f901e3ff__"